import { render, staticRenderFns } from "./OtherPrescription.vue?vue&type=template&id=1c163e9b&"
import script from "./OtherPrescription.vue?vue&type=script&lang=js&"
export * from "./OtherPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports